// extracted by mini-css-extract-plugin
export default {"root":"oeWIOw","container":"Ebr6AI","listItem":"Rhimou","link":"Q8t1PH","image":"qFhtwZ"};